import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { SearchHistoryEntry, SearchInputType } from "../../model";

/**
 * Unified service for managing search history and autocomplete suggestions
 * Replaces distributed suggestion management across multiple services
 */
@Injectable({
  providedIn: "root",
})
export class SearchHistoryService {
  private readonly STORAGE_KEY = "search-enhance-history";

  private readonly MAX_HISTORY_ENTRIES = 50;

  private historySubject = new BehaviorSubject<SearchHistoryEntry[]>([]);

  constructor() {
    this.loadHistoryFromStorage();
  }

  // /**
  //  * Add or update search entry in history
  //  * @param text Search text
  //  * @param type Detected input type
  //  * @param data Optional data to store for faster retrieval
  //  */
  // addToHistory(
  //   text: string,
  //   type: Searchtype,
  //   data?: {
  //     coordinates?: [number, number];
  //     wktGeometry?: string;
  //     placeId?: string;
  //   },
  // ): void {
  //   if (!text?.trim()) return;
  //
  //   const history = this.historySubject.value;
  //   const normalizedText = text.trim();
  //   const existingIndex = history.findIndex((entry) => entry.text.toLowerCase() === normalizedText.toLowerCase());
  //
  //   let updatedHistory: SearchHistoryEntry[];
  //
  //   if (existingIndex >= 0) {
  //     // Update existing entry
  //     updatedHistory = [...history];
  //     updatedHistory[existingIndex] = {
  //       ...updatedHistory[existingIndex],
  //       lastUsed: new Date(),
  //       usage: updatedHistory[existingIndex].usage + 1,
  //       type, // Update type in case it changed
  //       data: data || updatedHistory[existingIndex].data,
  //     };
  //   } else {
  //     // Add new entry
  //     const newEntry: SearchHistoryEntry = {
  //       text: normalizedText,
  //       type,
  //       lastUsed: new Date(),
  //       usage: 1,
  //       data,
  //     };
  //     updatedHistory = [newEntry, ...history].slice(0, this.MAX_HISTORY_ENTRIES);
  //   }
  //
  //   this.historySubject.next(updatedHistory);
  //   this.saveHistoryToStorage(updatedHistory);
  // }
  //
  // /**
  //  * Get filtered suggestions based on input and display mode compatibility
  //  * @param input Current user input (can be empty for recent history)
  //  * @param allowedTypes Array of allowed input types for current display mode
  //  * @returns Array of autocomplete suggestions
  //  */
  // getFilteredSuggestions(input: string, allowedTypes: Searchtype[]): UnifiedAutocompleteSuggestion[] {
  //   const history = this.historySubject.value;
  //
  //   if (!input?.trim()) {
  //     // Return recent history filtered by allowed types
  //     return history
  //       .filter((entry) => allowedTypes.includes(entry.type))
  //       .sort((a, b) => b.lastUsed.getTime() - a.lastUsed.getTime())
  //       .slice(0, this.MAX_SUGGESTIONS)
  //       .map((entry) => this.entryToSuggestion(entry));
  //   }
  //
  //   // Filter by input text and allowed types
  //   const inputLower = input.toLowerCase();
  //   return history
  //     .filter((entry) => entry.text.toLowerCase().includes(inputLower) && allowedTypes.includes(entry.type))
  //     .sort((a, b) => {
  //       // Sort by usage and recency
  //       const usageScore = b.usage - a.usage;
  //       const recencyScore = b.lastUsed.getTime() - a.lastUsed.getTime();
  //       return usageScore || recencyScore;
  //     })
  //     .slice(0, this.MAX_SUGGESTIONS)
  //     .map((entry) => this.entryToSuggestion(entry));
  // }
  //
  // /**
  //  * Convert history entry to unified autocomplete suggestion
  //  * @param entry History entry
  //  * @returns Autocomplete suggestion
  //  */
  // private entryToSuggestion(entry: SearchHistoryEntry): UnifiedAutocompleteSuggestion {
  //   const suggestion: UnifiedAutocompleteSuggestion = {
  //     text: entry.text,
  //     type: entry.type,
  //     icon: this.getIconForType(entry.type),
  //     confidence: 0.8, // Historical entries have good confidence
  //     lastUsed: entry.lastUsed,
  //     usage: entry.usage,
  //   };
  //
  //   // Add stored data if available
  //   if (entry.data) {
  //     if (entry.data.coordinates) {
  //       suggestion.coordinates = entry.data.coordinates;
  //     }
  //     if (entry.data.wktGeometry) {
  //       suggestion.geometryData = {
  //         wkt: entry.data.wktGeometry,
  //         boundingBox: [0, 0, 0, 0], // TODO: Extract from WKT
  //       };
  //     }
  //     if (entry.data.placeId) {
  //       suggestion.placesData = {
  //         placeId: entry.data.placeId,
  //         description: entry.text,
  //         types: [],
  //       };
  //     }
  //   }
  //
  //   return suggestion;
  // }
  //
  // /**
  //  * Get Material icon for input type
  //  * @param type The input type
  //  * @returns Material icon name
  //  */
  // private getIconForType(type: SearchInputType): string {
  //   switch (type) {
  //     case SearchInputType.COORDINATE:
  //       return "location_on";
  //     case SearchInputType.WKT_GEOMETRY:
  //       return "polyline";
  //     case SearchInputType.GOOGLE_PLACE:
  //       return "place";
  //     case SearchInputType.TEXT:
  //     default:
  //       return "search";
  //   }
  // }
  //
  // /**
  //  * Clear all search history
  //  */
  // clearHistory(): void {
  //   this.historySubject.next([]);
  //   this.removeHistoryFromStorage();
  // }
  //
  // /**
  //  * Remove specific entry from history
  //  * @param text Text to remove
  //  */
  // removeFromHistory(text: string): void {
  //   const history = this.historySubject.value;
  //   const filtered = history.filter((entry) => entry.text.toLowerCase() !== text.toLowerCase());
  //   this.historySubject.next(filtered);
  //   this.saveHistoryToStorage(filtered);
  // }

  /**
   * Load history from localStorage
   */
  private loadHistoryFromStorage(): void {
    try {
      const stored = localStorage.getItem(this.STORAGE_KEY);
      if (stored) {
        const entries: SearchHistoryEntry[] = JSON.parse(stored);
        const processedEntries = entries.map((entry) => ({
          ...entry,
          lastUsed: new Date(entry.lastUsed),
        }));
        this.historySubject.next(processedEntries);
      }
    } catch (error) {
      console.error("Failed to load search history from storage:", error);
    }
  }

  /**
   * Save history to localStorage
   * @param history History entries to save
   */
  private saveHistoryToStorage(history: SearchHistoryEntry[]): void {
    try {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(history));
    } catch (error) {
      console.error("Failed to save search history to storage:", error);
    }
  }

  /**
   * Remove history from localStorage
   */
  private removeHistoryFromStorage(): void {
    try {
      localStorage.removeItem(this.STORAGE_KEY);
    } catch (error) {
      console.error("Failed to remove search history from storage:", error);
    }
  }

  // ========================================
  // NEW SIMPLIFIED HISTORY FUNCTIONS
  // ========================================

  /**
   * Only saves ADDRESS and TEXT types (coordinates/geometries are real-time)
   *
   * @param query - The search query text
   * @param searchType - The detected search type
   * @param confidence - Detection confidence (0-1)
   * @param data
   */
  addTypedSearch(query: string, searchType: SearchInputType, confidence: number, data: any = null): void {
    // Only save ADDRESS and TEXT types to history
    // Coordinates and geometries are generated in real-time
    if (searchType !== SearchInputType.GOOGLE_PLACE && searchType !== SearchInputType.TEXT) {
      return;
    }

    if (!query?.trim()) {
      return;
    }

    const normalizedQuery = query.trim();
    const history = this.historySubject.value;

    // Check for recent duplicate (same query within last 5 minutes)
    const fiveMinutesAgo = Date.now() - 5 * 60 * 1000;
    const recentDuplicate = history.find(
      (entry) =>
        entry.text.toLowerCase() === normalizedQuery.toLowerCase() && entry.lastUsed.getTime() > fiveMinutesAgo,
    );

    if (recentDuplicate) {
      return;
    }

    // Find existing entry to update or create new one
    const existingIndex = history.findIndex((entry) => entry.text.toLowerCase() === normalizedQuery.toLowerCase());

    let updatedHistory: SearchHistoryEntry[];

    if (existingIndex >= 0) {
      // Update existing entry
      const existingEntry = history[existingIndex];
      const updatedEntry: SearchHistoryEntry = {
        ...existingEntry,
        lastUsed: new Date(),
        usage: existingEntry.usage + 1,
        type: searchType, // Update type in case detection improved
      };

      updatedHistory = [updatedEntry, ...history.slice(0, existingIndex), ...history.slice(existingIndex + 1)];
    } else {
      // Create new entry
      const newEntry: SearchHistoryEntry = {
        text: normalizedQuery,
        type: searchType,
        lastUsed: new Date(),
        data: data,
        usage: 1,
      };

      updatedHistory = [newEntry, ...history];
    }

    // Limit history size
    if (updatedHistory.length > this.MAX_HISTORY_ENTRIES) {
      updatedHistory = updatedHistory.slice(0, this.MAX_HISTORY_ENTRIES);
    }

    this.historySubject.next(updatedHistory);
    this.saveHistoryToStorage(updatedHistory);
  }

  /**
   * Only returns ADDRESS and TEXT types that match the input
   *
   * @param inputText - Current input text to filter by
   * @param allowedTypes - Optional filter by specific types
   * @param maxResults - Maximum number of results to return
   */
  getFilteredHistory(
    inputText: string,
    allowedTypes: SearchInputType[] = [],
    maxResults: number = 5,
  ): SearchHistoryEntry[] {
    const history = this.historySubject.value;
    const searchTerm = inputText.toLowerCase().trim();

    // Filter by text match and allowed types
    const filtered = history.filter((entry) => {
      // Text match (if search term provided)
      const textMatch = !searchTerm || entry.text.toLowerCase().includes(searchTerm);

      // Type match (only ADDRESS and TEXT are stored)
      const typeMatch = allowedTypes.length === 0 || allowedTypes.includes(entry.type);

      return textMatch && typeMatch;
    });

    // Sort by relevance: exact matches first, then by usage and recency
    const sorted = filtered.sort((a, b) => {
      // Exact match bonus
      const aExact = a.text.toLowerCase() === searchTerm ? 1000 : 0;
      const bExact = b.text.toLowerCase() === searchTerm ? 1000 : 0;

      if (aExact !== bExact) return bExact - aExact;

      // Usage frequency (higher usage first)
      const usageDiff = b.usage - a.usage;
      if (usageDiff !== 0) return usageDiff;

      // Recency (more recent first)
      return b.lastUsed.getTime() - a.lastUsed.getTime();
    });

    return sorted.slice(0, maxResults);
  }
}
